import { Autocomplete, TextField, TextFieldProps } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getIntersection, getIntersectionByKey } from "../../utilities/filter";

interface IProps {
	list: any[]; //массив объектов для выпадающего списка
	label?: string;
	objects?: boolean; //если true, когда props.value[props.keyValue] - массив объектов
	value: any; //объект
	setValue(value: any): void; //функция обновления объекта
	keyValue: string; //ключ массива в объекте
	keyItemValue?: string; //ключ значения элемента массива
	keyItemTitle?: string; //ключ названия элемента массива
	renderItemTitle?(item: any): string; //функция для получения названия элемента массива
	inputProps?: TextFieldProps;
	className?: string;
}

const DataMultiSelect = (props: IProps) => {
	const [value, setValue] = useState<any[]>([]);

	const getTitle = (option: any) => {
		if (props.renderItemTitle) return props.renderItemTitle(option);
		return option[props.keyItemTitle || "name"];
	};

	useEffect(() => {
		if (props.keyValue in props.value) {
			const res = props.objects
				? getIntersection(
						props.list,
						props.value[props.keyValue],
						props.keyItemValue
				  )
				: getIntersectionByKey(
						props.list,
						props.value[props.keyValue],
						props.keyItemValue
				  );
			setValue(res);
		} else setValue([]);
	}, [
		props.keyItemValue,
		props.keyValue,
		props.list,
		props.objects,
		props.value,
	]);

	return (
		<Autocomplete
			className={props.className || "w-[400px]"}
			disablePortal
			multiple
			filterSelectedOptions
			options={props.list}
			onChange={(e, v) => {
				var eventVal = { ...props.value };
				if (v) {
					eventVal[props.keyValue] = v.map(
						(e) => e[props.keyItemValue || "id"]
					);
				} else delete eventVal[props.keyValue];
				setValue(v);
				props.setValue({ ...eventVal });
			}}
			value={value}
			getOptionLabel={(option) => getTitle(option)}
			renderOption={(prop, option) => {
				return (
					<li {...prop} key={option[props.keyItemValue || "id"]}>
						{getTitle(option)}
					</li>
				);
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					{...props.inputProps}
					label={props.label || ""}
					variant={"standard"}
				/>
			)}
		/>
	);
};

export default DataMultiSelect;
